const serviceModel = document.querySelector('.js-service-model');
const buttons = [...document.querySelectorAll('.js-service-model-button')];
const shapes = [...document.querySelectorAll('.js-service-model-shape')];

function setCurrent(index) {
    // const navToggle = nav.querySelector(`.js-service-model-button[data-index="${index}"]`);
    // const navToggleOffset = navToggle.offsetLeft;
    // nav.scrollTo(navToggleOffset - 25, 0);

    buttons.forEach((button) => {
        button.classList.remove('is-current');
    });

    shapes.forEach((shape) => {
        shape.style.opacity = '0';
    });

    buttons
        .filter(button => Number(button.getAttribute('data-index')) === index)
        .forEach((button) => {
            button.classList.add('is-current');
        });

    shapes
        .filter(shape => Number(shape.getAttribute('data-index')) === index)
        .forEach((shape) => {
            shape.style.opacity = '';
        });
}

if (serviceModel) {
    const flkty = new window.Flickity(serviceModel, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        initialIndex: 4,
        prevNextButtons: false,
    });

    [...buttons, ...shapes].forEach((button) => {
        const index = button.getAttribute('data-index') || 0;

        button.addEventListener('click', () => {
            flkty.select(index, false, true);
        });
    });

    setCurrent(4);

    flkty.on('select', setCurrent);
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/serviceModel.js